import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject25() {
  var data = _taggedTemplateLiteral(["\n        width: 100%;\n        justify-content: center;\n    "]);

  _templateObject25 = function _templateObject25() {
    return data;
  };

  return data;
}

function _templateObject24() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    ", "\n"]);

  _templateObject24 = function _templateObject24() {
    return data;
  };

  return data;
}

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n        margin-right: 0;\n        margin-bottom: ", ";\n    "]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    min-width: 150px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-right: ", ";\n    ", "\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: ", ";\n    background-color: ", ";\n    border-radius: ", ";\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n        display: none;\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 25%;\n    ", "\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n            height: fit-content;\n            flex-direction: column;\n            padding: ", " 0;\n        "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n        display: flex;\n        justify-content: center;\n        flex-direction: row;\n        flex-flow: row nowrap;\n        width: ", ";\n        max-width: 100%;\n        min-height: 185px;\n        height: fit-content;\n        border-radius: ", ";\n        border: ", " dashed #bccacb;\n        background-color: #ffffff;\n\n        ", "\n\n        ", "\n    "]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 200px;\n    white-space: nowrap;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n        max-width: 100%;\n        padding: 0 2%;\n    "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: 200px;\n    white-space: nowrap;\n    ", "\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    text-align: center;\n    text-justify: inter-word;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n    text-align: center;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n        font-family: ", ";\n        font-size: ", ";\n        font-weight: ", ";\n        line-height: ", ";\n    "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n        max-width: ", ";\n        max-height: ", ";\n        margin-right: ", ";\n        font-size: ", ";\n        color: ", ";\n        cursor: pointer;\n        transform: translate(0%, 15%);\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        display: none;\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 25%;\n    font-size: 70px;\n    color: ", ";\n\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n                margin-right: 0px;\n                margin-left: 6px;\n                display: block;\n            "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            width: 100%;\n\n            & > button {\n                font-size: 0;\n                text-align: center;\n                margin: 0px auto;\n                width: 50%;\n            }\n\n            ", " {\n                max-height: ", ";\n                max-width: ", ";\n                font-size: ", ";\n                transform: translate(0%, 0%);\n            }\n        "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        width: 33.33%;\n        text-align: center;\n\n        ", "\n\n\n        ", "\n\n\n        ", " {\n            max-height: ", ";\n            max-width: ", ";\n            font-size: ", ";\n            margin-right: 9px ;\n            display: none;\n            transform: translate(0%, 0%);\n\n            ", "\n        }\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Icon } from '../Icon';
import { Button } from '../Button';
export var StyledUploadButton = styled.div(_templateObject(), function (props) {
  return css(_templateObject2(), media.smaller(_templateObject3(), Icon.Styles.StyledIcon, props.theme.components.inputFileUpload.iconFontSize, props.theme.components.inputFileUpload.iconFontSize, props.theme.components.inputFileUpload.iconFontSize), props.error && !props.disabled ? "\n                    ".concat(Button.Styles.StyledButton, "{\n                        background-color: ").concat(props.theme.components.inputFileUpload.errorColor, ";\n                    }\n\n                    &:hover{\n                        ").concat(Button.Styles.StyledButton, "{\n                            background-color: #f05b5b;\n                        }\n                    }") : '', Icon.Styles.StyledIcon, props.theme.components.inputFileUpload.iconFontSize, props.theme.components.inputFileUpload.iconFontSize, props.theme.components.inputFileUpload.iconFontSize, media.smaller(_templateObject4()));
});
export var StyledIcon = styled(Icon)(_templateObject5(), function (props) {
  return props.theme.components.inputFileUpload.iconColor;
}, media.smaller(_templateObject6()));
export var StyledTrashIcon = styled(Icon)(_templateObject7(), function (props) {
  return css(_templateObject8(), props.theme.components.inputFileUpload.fileIconFontSize, props.theme.components.inputFileUpload.fileIconFontSize, props.theme.components.inputFileUpload.marginRightFileIcon, props.theme.components.inputFileUpload.fileIconFontSize, props.theme.global.colors.error);
});
var Typography = styled.div(_templateObject9(), function (props) {
  return css(_templateObject10(), props.theme.global.typographyConfig.headings.fontFamily, props.theme.components.inputFileUpload.fontSize, props.theme.components.inputFileUpload.fontWeight, props.theme.components.inputFileUpload.lineHeight);
});
export var StyledBottomLabel = styled(Typography)(_templateObject11(), function (props) {
  return props.theme.components.inputFileUpload.bottomLabelColor;
});
export var StyledTopLabel = styled(Typography)(_templateObject12(), function (props) {
  return props.theme.components.inputFileUpload.topLabelColor;
});
export var StyledFileName = styled(Typography)(_templateObject13(), function (props) {
  return props.theme.components.inputFileUpload.fileNameColor;
}, media.smaller(_templateObject14()));
export var StyledErrorMessage = styled(Typography)(_templateObject15(), function (props) {
  return props.theme.components.inputFileUpload.errorColor;
});
export var StyledDropeZone = styled.div(_templateObject16(), function (props) {
  return css(_templateObject17(), props.width, props.theme.components.inputFileUpload.dropZoneBorderRadius, props.theme.components.inputFileUpload.dropZoneBorderWidth, props.disabled && "border: ".concat(props.theme.components.inputFileUpload.dropZoneBorderWidth, " solid #b3b3b3;"), media.smaller(_templateObject18(), props.theme.global.spaces.lowFrequencyUltraviolet));
});
export var ContainerSvg = styled.div(_templateObject19(), media.smaller(_templateObject20()));
export var Svg = styled.div(_templateObject21(), function (props) {
  return props.theme.global.spaces.lowFrequencyUltraviolet;
}, function (props) {
  return props.theme.global.colors.concreteDark;
}, function (props) {
  return props.radius;
});
export var FileNames = styled.div(_templateObject22(), function (props) {
  return props.theme.global.spaces.lowFrequencyUltraviolet;
}, media.smaller(_templateObject23(), function (props) {
  return props.theme.global.spaces.lowFrequencyUltraviolet;
}));
export var FileName = styled.div(_templateObject24(), media.smaller(_templateObject25()));